export default __webpack_public_path__ + "static/K2Nintex-5acad6b0472acfa4d87c0fc6ca775cda.png";